import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let SBProMenuDocumentation = class SBProMenuDocumentation extends Vue {
    mounted() {
        // 在大屏幕上启用hover显示菜单
        if (window.innerWidth >= 992) {
            const dropdown = this.$el;
            if (dropdown) {
                const dropdownMenu = dropdown.querySelector('.dropdown-menu');
                const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
                if (dropdownMenu && dropdownToggle) {
                    let hideTimeout = null;
                    const showMenu = () => {
                        if (hideTimeout) {
                            clearTimeout(hideTimeout);
                            hideTimeout = null;
                        }
                        dropdown.classList.add('show');
                        dropdownMenu.style.display = 'block';
                        dropdownMenu.style.opacity = '1';
                        dropdownMenu.style.visibility = 'visible';
                    };
                    const hideMenu = () => {
                        hideTimeout = window.setTimeout(() => {
                            dropdown.classList.remove('show');
                            dropdownMenu.style.display = 'none';
                            dropdownMenu.style.opacity = '0';
                            dropdownMenu.style.visibility = 'hidden';
                        }, 100);
                    };
                    dropdown.addEventListener('mouseenter', showMenu);
                    dropdown.addEventListener('mouseleave', hideMenu);
                    dropdownMenu.addEventListener('mouseenter', showMenu);
                    dropdownMenu.addEventListener('mouseleave', hideMenu);
                }
            }
        }
    }
};
SBProMenuDocumentation = __decorate([
    Component({})
], SBProMenuDocumentation);
export default SBProMenuDocumentation;
